import type { MeResponse } from '@/api/types/User'

const CURRENT_ORG_KEY = 'fuzzyCurrentOrganizationID'

export const updateCurrentOrganization = (orgId: MeResponse['organizations'][number]['id']) => {
  localStorage.setItem(CURRENT_ORG_KEY, orgId)
}

export const currentOrganizationDecider = (availableOrgs?: MeResponse['organizations']) => {
  // If no organizations, remove any saved ID and return undefined
  if (!availableOrgs || !Array.isArray(availableOrgs) || availableOrgs.length === 0) {
    localStorage.removeItem(CURRENT_ORG_KEY)
    return undefined
  }

  // Find "ioid" param in URL
  const urlParams = new URLSearchParams(window.location.search)
  const ioidParam = urlParams.get('ioid')

  // If "ioid" param exists and matches an organization ID, save and return that organization
  if (ioidParam?.length && availableOrgs.some(org => org.id === ioidParam)) {
    localStorage.setItem(CURRENT_ORG_KEY, ioidParam)
    return availableOrgs.find(org => org.id === ioidParam)
  }

  // Get the saved ID from localStorage
  const savedOrgId = localStorage.getItem(CURRENT_ORG_KEY)
  const foundOrg = availableOrgs.find(org => org.id === savedOrgId)

  // If the saved ID is still valid, return the organization
  if (savedOrgId && foundOrg) {
    return foundOrg
  }

  // Otherwise, save and return the first organization
  const firstOrg = availableOrgs[0]
  localStorage.setItem(CURRENT_ORG_KEY, firstOrg.id)
  return firstOrg
}
